<template>
  <div class="meeting-live1">
    <top :title="liveDetails.button_name || '大会直播'" :color="theme_color"></top>
    <div v-if="hasAuth == true" class="all">
      <van-sticky :offset-top="0" @change="checkElementAtTop">
        <div class="timeTabs-wrap" v-if="meetingSchedule.length != 0" id="top">
          <div :class="isTabsFixed ? 'icon_show' : 'icon_hide'">
            <van-icon name="arrow-left" size="24" @click="onClickLeft" />
          </div>

          <div class="timeTabs-wrap-inner">
            <div class="timeTabs" v-if="theme_color">
              <div class="tab-item" @click="switchDate(item)" :style="{
                background: schedule_active ? theme_color : '',
                border: schedule_active ? 'none' : ''
              }">
                {{ scheduleDate1[0] }}
              </div>
            </div>
            <div class="timeTabs" v-else>
              <div class="tab-item active" @click="switchDate(item)">
                {{ scheduleDate1[0] }}
              </div>
            </div>
            <h3>
              {{
                liveDetails.daily_preview_title
                  ? liveDetails.daily_preview_title
                  : liveDetails.name
              }}
              <span v-if="liveDetails.hall_name">（{{ liveDetails.hall_name }}）</span>
            </h3>
          </div>
          <div :class="isTabsFixed ? 'icon_show' : 'icon_hide'">
            <van-icon name="wap-home-o" size="24" @click="goHome" />
          </div>
        </div>
        <div class="video" id="video">
          <div class="viewNumber" v-if="liveDetails.show_views && liveDetails.only_show_banner == 0">
            观看人数 : {{ viewNum }}人
          </div>
          <p class="viewNumber" v-if="liveDetails.meeting && liveDetails.meeting.show_views"> 观看人数 : {{ viewNum }}人
          </p>
          <player ref="player" :videoUrl="videoUrl" v-if="JSON.stringify(liveDetails) != '{}' &&
            liveDetails.only_show_banner == 0
          "></player>
          <img :src="liveDetails.banner" style="width:100%" v-if="liveDetails.banner_type == 1 && liveDetails.only_show_banner == 1
          " />

          <div class="bgCover2" v-if="liveDetails.banner_type == 2 && liveDetails.only_show_banner == 1
          ">
            <img :src="liveDetails.banner" alt="" />
            <ul>
              <p>
                {{ liveDetails.time }}{{ liveDetails.name
                }}{{
                  liveDetails.hall_name ? "(" + liveDetails.hall_name + ")" : ""
                }}
              </p>
              <li v-for="(ct, c) in meetingSchedule[scheduleDate1[0]][liveDetails.name]" :key="c">
                {{ ct.name }}
              </li>
            </ul>
          </div>
          <div class="lines-buttons" v-if="more_lines"
            style="text-align:center;padding:10px;background-color: #fff;width: 100%;">
            <van-button v-for="(item, index) in line_buttons" :key="index" size="small" :style="{
              'margin-right': index < line_buttons.length - 1 ? '10px' : ''
            }" :color="line_index == index ? '#d2020d' : ''" @click="changeLine(item, index)">{{ item.rtc_name
              }}</van-button>
          </div>

          <div class="swiper-img">
            <van-swipe :autoplay="3000" indicator-color="white">
              <van-swipe-item v-for="(item, index) in swiperImg" :key="index" @click="clickSwiperImg(item)">
                <img :src="item.banner_url" alt="" />
              </van-swipe-item>
            </van-swipe>
          </div>
        </div>
        <!-- <div class="hr-7" ref="line"></div> -->
      </van-sticky>

      <div class="container">
        <van-tabs v-model="active" animated swipeable :sticky="isTabsFixed" :offset-top="tabsOffTop" z-index="999"
          color="#901d22" title-inactive-color="#999" title-active-color="#090909">
          <van-tab title="日程安排" v-if="show_detail == true">
            <schedule ref="schedule" :meetingSchedule="meetingSchedule" :color="theme_color" :endTime="meetingEndTime"
              @getLiveInfo="getLiveInfo" @initPageScroll="initPageScroll" @showChargePopup="showChargePopup"
              :isWxBtn="isWxBtn" :meetingInfo="liveDetails.meeting" @subscribeTime="subscribeTime"  @showWantLook="showWantLook" ></schedule>
          </van-tab>
          <van-tab title="会议介绍" v-else>
            <introduction :meetingDes="meetingDes"></introduction>
          </van-tab>
          <van-tab title="互动讨论">
            <discuss ref="discuss" :admin="admin" :websock="websock" :topicList="topicList" :color="theme_color">
            </discuss>
          </van-tab>
          <van-tab title="切换会场" v-if="is_show_meetingPlace == true">
            <meeting-place :scheduleDate="scheduleDate" :weekdays="weekdays" :meetingSchedule="meetingSchedules"
              :color="theme_color"></meeting-place>
          </van-tab>
          <van-tab title="会议介绍" v-if="is_show_des && show_detail == true">
            <introduction :meetingDes="meetingDes"></introduction>
          </van-tab>
        </van-tabs>
      </div>
    </div>
    <van-popup v-model="showActivity" position="center" @close="closePop" :close-on-click-overlay="closeOverlay">
      <collect-info :fieldArr="fieldArr" :formset="formset" @func="changeInfoStatus" :mobile="userInfo.mobile"
        @changeAuth="changeAuth($event)"></collect-info>
    </van-popup>
    <!-- 手机号 -->
    <van-popup v-model="is_show_phone_popup" position="center" class="phone_popup"
      :style="{ width: '80%', 'min-height': '210px' }">
      <h4>请输入您的手机号</h4>
      <van-field v-model="updateMobile" type="tel" label="手机号" :label-width="80" />
      <div class="submit" @click="submitPhone">提交</div>
    </van-popup>
    <!-- 弹出二维码 -->
    <van-popup v-model="is_show_recommend_qrcode" closeable position="center" class="qrcode"
      :style="{ width: '280px', height: '280px' }">
      <img  :src="liveDetails.recommend_qrcode_url" alt="" />
    </van-popup>
    <!-- 弹出二维码 -->
    <van-popup v-model="is_show_extend" closeable position="bottom" class="extend"
      :style="{ width: '100%', height: '280px' }">
      <div class="half">
        <span class="attention">关注</span>
        <img :src="extend_pop.live_ad_img" alt="" />
      </div>
      <div class="half">
        <p v-html="extend_pop.live_ad_content" class="extend-content"></p>
      </div>
    </van-popup>
    <!-- 注册付费 -->
    <img v-if="is_show_charge" class="icon_charge_top" src="@/assets/images/Meeting/Meeting_playback.png" alt="">
    <van-popup v-model="is_show_charge" position="center" class="charge"
      :style="{ 'width': '80%', 'min-height': '216px', 'border-radius': '10px' }" :close-on-click-overlay="false">
      <div class="filter"></div>
      <h4>注册付费，观看录播回放</h4>
      <p>注册付费后<br>
        即可观看录播回放</p>
      <div class="handles">
        <div class="no" @click="is_show_charge = false">不用了</div>
        <div class="red" @click="goRegisterCharge">去注册</div>
      </div>
    </van-popup>
    <!-- 会议密码 -->
    <van-popup v-model="is_show_meeting_password" position="center" class="pwd_popup"
      :style="{ 'max-width': '360px', 'width': '80%', 'padding': '30px 20px 0', 'border-radius': '20px' }"
      :close-on-click-overlay="false">
      <h4>请输入会议密码</h4>
      <van-field v-model="passwordInputValue" type="text" label="密码" :label-width="80" />
      <div class="submit" @click="confirmMeetingPwd">确定</div>
    </van-popup>
    <!-- 订阅时间 -->
    <van-popup v-model="showChooseTime" round class="popup-box">
      <div style="margin-top:20px;">
        <h2>请选择在本场会议正式开始前</h2>
        <van-field readonly clickable name="picker" :value="pre_time" placeholder="点击选择时间" right-icon="arrow-down"
          @click="showPicker = true"
          style="width:100px;display: inline-block;vertical-align: bottom;border: 1px solid #DCDFE6;border-radius:5px;" />
        <span style="font-size:20px;line-height:46px;">分钟</span>
        <h2 style="margin-top:10px;">通过服务号消息提醒您观看直播</h2>
        <button @click.stop="submitSubscribe">确定</button>
      </div>

    </van-popup>
    <van-popup v-model="showPicker" position="bottom" :style="{ height: '300px' }">
      <van-picker show-toolbar :columns="columns" @confirm="onConfirm" @cancel="showPicker = false" title="请选择时间" />
    </van-popup>
    <!-- 登录注册medwiki -->
    <img v-if="show_bind_wiki" class="icon_charge_top sp" src="@/assets/images/Meeting/Meeting_playback.png" alt="">
    <van-popup v-model="show_bind_wiki" position="center" class="charge"
      :style="{ 'width': '80%', 'min-height': '216px', 'border-radius': '10px', 'max-width': '500px' }"
      :close-on-click-overlay="false">
      <div class="filter"></div>
      <h4 style="margin-bottom: 10px;">认证即可免费观看</h4>
      <p style="text-align: left;">原价1000元的参会门票，通过Wiki注册认证，即可免费观会!<br>
        限时免费时间：2025年4月23日-5月23日 </p>
      <div class="handles">
        <div class="no" @click="goBack">不用了</div>
        <div class="red" @click="goWikiLogin">去认证</div>
      </div>
    </van-popup>
    <!-- 收集认证信息用户真实姓名 -->
    <van-popup v-model="show_collect_username" position="center" class="charge" :close-on-click-overlay="false"
      :style="{ width: '80%', 'min-height': '210px', 'max-width': '500px' }">
      <h3>认证信息</h3>
      <van-field v-model="userAuthInfo.username" type="tel" :border="false" placeholder="真实姓名" required />
      <div class="handles">
        <div class="no" @click="goBack">取消</div>
        <div :style="{ background: theme_color }" class="red" @click="submitAuthInfo">确定</div>
      </div>
    </van-popup>
    <!-- 收集用户认证信息 -->
    <van-popup v-model="show_collect_authInfo" position="center" class="charge" :close-on-click-overlay="false"
      :style="{ 'width': '80%', 'min-height': '216px', 'border-radius': '10px', 'max-width': '500px' }">
      <h3>认证信息</h3>
      <van-field v-model="userAuthInfo.username" :border="false" placeholder="真实姓名" required />
      <van-field v-model="userAuthInfo.age" :border="false" placeholder="年龄段" readonly required is-link
        @click="showPickerAge = true" />
      <van-field v-model="userAuthInfo.hospital" :border="false" placeholder="医院/企业" required />
      <van-field v-model="userAuthInfo.depart_name" :border="false" placeholder="科室" readonly required is-link
        @click="showPickerDepart = true" />
      <van-field v-model="userAuthInfo.job_name" :border="false" placeholder="职称" readonly required is-link
        @click="showPickerJob = true" />
      <div class="handles">
        <div class="no" @click="goBack">取消</div>
        <div :style="{ background: theme_color }" class="red" @click="submitAuthInfo">确定</div>
      </div>
    </van-popup>
    <van-popup v-model="showPickerAge" position="bottom" :style="{ height: '300px' }">
      <van-picker :columns="ages" v-model="userAuthInfo.age" value-key="name" @confirm="onSelectAge" show-toolbar
        @cancel="showPickerAge = false" title="请选择年龄段" />
    </van-popup>
    <van-popup v-model="showPickerJob" position="bottom" :style="{ height: '300px' }">
      <van-picker :columns="jobs" value-key="name" @confirm="onSelectJob" show-toolbar @cancel="showPickerJob = false"
        title="请选择职称" />
    </van-popup>
    <van-popup v-model="showPickerDepart" position="bottom" :style="{ height: '300px' }">
      <van-picker :columns="departs" value-key="name" @confirm="onSelectDepart" show-toolbar
        @cancel="showPickerDepart = false" title="请选择科室" />
    </van-popup>
    <div class="want_look_tip" v-if="showWantLookTip">
			您想看的内容后续会在Med Wiki发布 <br>敬请关注
		</div>
  </div>
</template>
<script>
import Schedule from "../components/Meeting/Schedule";
import Discuss from "../components/Meeting/Discuss";
import MeetingPlace from "../components/Meeting/MeetingPlace";
import CollectInfo from "@/components/Meeting/CollectInfo";
import Player from "@/components/Meeting/Player";
import Introduction from "@/components/Meeting/Introduction";
import Top from "../components/Top";
import { Sticky, Field, Toast, Dialog } from "vant";
import { WxShare, UpdateUserInfo, MeetingsAuthList, CollectUserAuth, RegisterWiki } from '../../../config/interface.js';
import wx from 'weixin-js-sdk'
import {
  MeetingBanner,
  MeetingsCollectInfo,
  MeetingsPlace,
  MeetingsPlaceDetails,
  SessionsViewsNum,
  PersoanalUserInfo,
  Signature,
  MeetingsSchedule,
  extendPop
} from "../../../config/interface.js";
import { set } from "nprogress";
export default {
  components: {
    Schedule,
    Discuss,
    MeetingPlace,
    Player,
    Introduction,
    Top,
    CollectInfo,
    Sticky,
    Field
  },
  data() {
    return {
      closeOverlay: false,
      time: 10 * 60 * 1000,
      admin: [], //超级管理员
      floatWindow: true, //浮窗
      showActivity: false, //活动展示
      viewGift: true, //观看直播得礼物
      active: 0,
      viewNum: 0, //观看人数
      liveDetails: {},
      meetingsPlace: [],
      signatureInfo: {},
      userInfo: "",
      meetingSchedule: [], //会议日程
      videoUrl: "", //视频url
      fieldArr: [], //字段
      swiperImg: [],
      is_show_recommend_qrcode: false, //二维码展示
      is_show_des: false, //显示会议介绍
      is_show_meetingPlace: false,
      meetingDes: "",
      scheduleDate: [],
      meetingSchedules: [],
      value: 0,
      websock: "",
      obj: "",
      room_id: this.$route.query.id, //房间号
      connectWebSocket: false, //websocket是否连接
      pingTimer: null, //定时器
      topicList: [], //话题列表
      hasAuth: false,
      formset: {},
      theme_color: "",
      is_show_extend: false,
      extend_pop: {},
      show_detail: true,
      more_lines: false,
      line_buttons: [],
      line_index: 0,
      timeout_count: 0,
      nav_title: "",
      schedule_active: 0,
      scheduleDate1: [],
      meetingEndTime: "",
      headTitle: "大会直播",
      isTabsFixed: false,
      tabsOffTop: 0,
      liveInfo2: {},
      weekdays: [],
      shareimg: '',
      is_show_charge: false,
      isWxBtn: false,
      is_show_phone_popup: false,
      updateMobile: '',
      showChooseTime: false,
      is_show_meeting_password: false,
      passwordInputValue: null,
      meeting_watch_password: null,
      meeting_watch_type: 1,
      showChooseTime: false,
      showPicker: false,
      showPickerAge: false,
      showPickerJob: false,
      showPickerDepart: false,
      customFieldName: {
        value: 'name',
        text: "name"
      },
      options: [
        {
          value: 5,
          label: '5分钟'
        },
        {
          value: 15,
          label: '15分钟'
        },
        {
          value: 30,
          label: '30分钟'
        }
      ],
      columns: [5, 15, 30],
      pre_time: 5,
      subscribe_item: {},
      subscribe_type: 0,
      show_bind_wiki: false,//登录注册medwiki，
      show_collect_username: false,
      show_collect_authInfo: false,
      userAuthInfo: {
        username: '',
        age: '',
        hospital: '',
        depart_name: '',
        job_name: ''
      },
      authAge: '70后',
      authJobName: '',
      authDepartName: '',
      liveStatus: 0,
      jobs: [],
      departs: [],
      ages: [],
      showWantLookTip:false
    };
  },
  watch: {
    topicList(oldData, newData) {
      this.isEmpty = newData.length > 0 ? false : true;
    }
  },
  beforeRouteEnter(to, from, next) {
		//  修复iOS版微信HTML5 History兼容性问题
		if (to.path !== location.pathname) {
			location.assign(to.fullPath)
		} else {
			next()
		}
	},
  created() {
    if (common.is_weixin()) {
      //微信端
      this.getUserInfo();
      // this.checkIOSAndReload();
    } else {
      //非微信端
      this.userInfo = this.$store.state.userInfo;
      if (this.userInfo) {
        this.getUserInfo();
      } else {
        this.$router.replace({
          path: "/vascularNews/user/login",
          query: { url: window.location.href }
        });
      }
    }

  },
  mounted() {
    // 添加监听器
    window.addEventListener("resize", this.checkElementAtTop);
    // this.$nextTick(() => {
    //   window.scrollTo({ top: 100, behavior: 'smooth' });
    // });
  },
  beforeDestroy() {
    // 移除监听器
    window.removeEventListener("resize", this.checkElementAtTop);
    clearInterval();
  },
  methods: {
    checkIOSAndReload() {
      const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
      if (isIOS && !sessionStorage.getItem('isReloaded')) {
        sessionStorage.setItem('isReloaded', 'true');
        window.location.reload();
      }
    },
    initPageScroll(id) {
      var element = document.querySelector("#" + id);
      var container = document.querySelector(".meeting-live1");
      element.scrollIntoView();
      container.scrollTo(
        0,
        container.scrollTop + element.getBoundingClientRect().top
      );
      console.log(container.scrollTop + element.getBoundingClientRect().top);
    },
    checkElementAtTop(e) {
      let element = document.getElementById("video");
      let element2 = document.getElementById("top");
      let height = element.offsetHeight;
      if (element2) {
        height += element2.offsetHeight;
      }
      this.tabsOffTop = height;
      console.log("resize", height);
      if (e && window.innerWidth < 1000) {
        setTimeout(() => {
          this.isTabsFixed = true;
        }, 50);
      } else {
        this.isTabsFixed = false;
      }


    },
    onClickLeft() {
      this.$router.go(-1);
    },
    showChargePopup() {
      this.is_show_charge = true
    },
    goHome() {
      this.$router.push({
        path: "/vascularNews/meeting/index",
        query: {
          meeting_id: this.meeting_id
        }
      });
    },
    //注册收费观看
    goRegisterCharge() {
      // 创建一个表示2024年8月28日0点的时间对象
      const targetDate = new Date("2024-08-28T00:00:00");
      // 获取当前时间
      const currentDate = new Date();
      // 判断当前时间是否在目标时间之后
      const isAfterTargetDate = currentDate > targetDate;
      console.log('当前时间是否在2024年8月28日0点之后:', isAfterTargetDate);
      if (isAfterTargetDate) {
        this.is_show_charge = false;
        setTimeout(() => {
          common.toast('注册报名已结束', 2000);
        }, 10)

      } else {
        this.$router.push({
          path: "/vascularNews/meeting/charge",
          query: {
            meeting_id: this.meeting_id
          }
        });
      }

    },
    //得到用户信息
    getUserInfo() {
      const url = PersoanalUserInfo;
      let params = {};
      const method = "POST";
      fetch(url, params, method).then(res => {
        if (res.code == 0) {
          let data = res.data;
          localStorage.setItem("userInfo", JSON.stringify(data));
          this.$store.dispatch("storageUserInfo", data);
          this.userInfo = data;
          if (this.userInfo && this.userInfo.mobile_status == 1) {
            // let top=this.$refs.line.getBoundingClientRect().top;
            // let bottom=this.$refs.line.getBoundingClientRect().bottom;
            this.id = this.$route.query.id;
            this.meeting_id = this.$route.query.meeting_id
              ? this.$route.query.meeting_id
              : this.$route.query.MT_id;
            this.getActivities();
          } else {
            common.toast("未绑定手机", 1000, "fail", () => {
              this.$router.replace({
                path: "/vascularNews/user/login",
                query: { url: window.location.href }
              });
            });
          }
        }
      });
    },
    subscribeTime(val) {
      this.showChooseTime = val > 0 ? true : false
    },
    showWantLook(){
      this.showWantLookTip=true
      setTimeout(()=>{
        this.showWantLookTip=false
      },2000)
    },
    //活动
    getActivities() {
      const url = MeetingsCollectInfo;
      const method = "POST";
      let params = {
        meeting_id: this.meeting_id
      };
      fetch(url, params, method).then(res => {
        if (res.code == 0) {
          let data = res.data;
          if (data.extend_columns.length != 0) {
            this.fieldArr = data.extend_columns;
            this.showActivity = Boolean(data.extend_columns.length);
            this.formset = data.formset;
          } else {
            this.hasAuth = true;
            // let top=this.$refs.line.getBoundingClientRect().top;
            // let bottom=this.$refs.line.getBoundingClientRect().bottom;
            this.getMeetingsPlaceDetails();
            this.getMeetingsPlace();
            this.getMeetingNumer();
            this.getBanner();
            this.getExtend();
            this.getDeparts()
          }
          this.$nextTick(() => {
            this.getSignature();
          });
        } else {
          if (res.code == 501) {
            this.hasAuth = false;
          }
        }
      });
    },
    closePop() {
      this.showActivity = false;
    },
    //切换日期
    switchDate(date) {
      // console.log('meetingSchedule1', this.meetingSchedule, date)
      if (date) {
        this.scheduleDate1 = Object.keys(this.meetingSchedule);
        console.log("scheduleDate22", this.scheduleDate1);
        this.schedule_active = date;
        this.scheduleList = this.meetingSchedules[date];
        // console.log('scheduleList',this.scheduleList)
      }
    },
    /**
     * 去注册
     */
    goRegister() {
      this.$router.push({
        path: "/user/register"
      });
    },
    //认证
    goWikiLogin() {
      fetch(RegisterWiki, {}, 'POST')
        .then((res) => {
          if (res.code == 0) {
            this.show_bind_wiki = false
            if (this.liveDetails.collect_user_profile) {
              this.userAuthInfo = this.liveDetails.collect_user_profile
            }
            //判断认证信息填写完全
            if (!(this.userAuthInfo && this.userAuthInfo.age && this.userAuthInfo.username && this.userAuthInfo.job_name && this.userAuthInfo.hospital && this.userAuthInfo.depart_name)) {
              this.show_collect_authInfo = true
            }

          }

        })
      // window.location.href = 'https://med.wiki/web/login?xgzx_user_id=' + this.userInfo.id + '&callback=' + encodeURIComponent(window.location.href)
    },
    onConfirm(val) {
      this.pre_time = val;
      this.showPicker = false
    },
    // canvasToShareImg(val){
    //   console.log('coverimg',val)
    //   this.shareimg=val
    // },
    //会场详情
    getMeetingsPlaceDetails() {
      this.$store.dispatch("isShowLoading", true);
      const url = MeetingsPlaceDetails;
      const method = "POST";
      let params = {
        session_id: this.id,
        chapter_id: this.$route.query.chapter_id
          ? this.$route.query.chapter_id
          : this.$route.query.c_id,
        scheme: window.location.protocol
      };
      fetch(url, params, method).then(res => {
        if (res.code == 0) {
          let data = res.data;
          this.liveDetails = data.session;
          // this.coverToImg();
          if (this.liveDetails.mobile_status == 0) {
            this.is_show_phone_popup = true
          }
          this.is_show_recommend_qrcode = this.liveDetails
            .is_show_recommend_qrcode
            ? true
            : false;
          this.is_show_des = this.liveDetails.is_show_des;
          if (this.liveDetails.company_areas.length == 0) {
            this.is_show_meetingPlace = true;
          }
          if (this.liveDetails && this.liveDetails.des) {
            this.meetingDes = this.liveDetails.des;
          } else {
            this.meetingDes = this.liveDetails.meeting.des;
          }

          if (
            this.liveDetails &&
            this.liveDetails.lines &&
            Object.keys(this.liveDetails.lines).length > 1
          ) {
            this.more_lines = true;
            this.line_buttons = [];
            let keys = Object.keys(this.liveDetails.lines);
            for (let i = 0; i < keys.length; i++) {
              this.line_buttons.push(this.liveDetails.lines[keys[i]]);
              if (i == 0) {
                data.session.play_url_m3u8 = this.liveDetails.lines[
                  keys[i]
                ].play_url_m3u8;
              }
            }
            console.log("line_buttons", this.line_buttons);
          }
          this.meetingSchedule = data.chapters;
          console.log("meetingSchedule", this.meetingSchedule);
          if (this.meetingSchedule) {
            this.scheduleDate1 = Object.keys(this.meetingSchedule);
            console.log("scheduleDate333", this.scheduleDate1);
            this.switchDate(this.scheduleDate1[0]);
          }
          if (this.liveDetails.daily_preview_title || this.liveDetails.name) {
            let title = this.liveDetails.daily_preview_title
              ? this.liveDetails.daily_preview_title
              : this.liveDetails.name;
            if (this.scheduleDate1) {
              title = this.scheduleDate1[0] + title;
            }
            if (this.liveDetails.hall_name) {
              title = title + "(" + this.liveDetails.hall_name + ")";
            }
            this.headTitle = title;
          }

          this.admin = data.session.admin;
          document.title = data.session.daily_preview_title
            ? data.session.daily_preview_title
            : data.session.name;
          if (common.is_weixin()) {

            let share_info = {}
            if (
              (this.$route.query.chapter_id || this.$route.query.c_id) &
              this.meetingSchedule &
              this.meetingSchedule.length
            ) {
              let date = Object.keys(data.chapters)[0];
              let obj = data.chapters[date];
              obj = obj[Object.keys(obj)[0]];
              share_info = {
                title: obj[0].name,
                desc: data.session.name,
                img: data.session.shareimg
              }
            } else {
              share_info = {
                title: data.session.name,
                desc: data.session.share_sub_title,
                img: data.session.shareimg
              }
            }
            this.$nextTick(() => {
              this.getWxConfig(share_info)
            })
          }
          if (data.session && data.session.hidden_details == 1) {
            this.show_detail = false;
          }
          //子组件加载完成后 向子组件传递数据
          this.$nextTick(() => {
            this.liveInfo2 = data.session;
            if (this.$refs.player) {
              this.$refs.player.getLiveInfo(data.session);
            }
          });


          this.$store.dispatch("isShowLoading", false);

          // 判断会议日程是否需要绑定medwiki
          if (data.session && data.session.bind_wiki_status && !data.session.bind_wiki_user_status) {
            this.show_bind_wiki = true;
          }
          // let meeting_end_time = data.session.end_at
          // let meeting_start_time = data.session.start_at
          // //判断当前时间会议是否直播
          // let arr1 = meeting_start_time.split(/[- : /]/);
          // this.liveStartTime = new Date(arr1[0], arr1[1] - 1, arr1[2], arr1[3], arr1[4], arr1[5]).getTime();
          // let arr2 = meeting_end_time.split(/[- : /]/);
          // this.liveEndTime = new Date(arr2[0], arr2[1] - 1, arr2[2], arr2[3], arr2[4], arr2[5]).getTime();
          // this.currentTime = new Date().getTime();
          // //直播
          // if (this.currentTime > this.liveEndTime) {
          //   console.log('直播已结束')
          //   this.liveStatus = 2;
          // } else if (this.currentTime < this.liveStartTime) {
          //   console.log('直播未开始')
          //   this.liveStatus = 0;
          // } else {
          //   console.log('直播中')
          //   this.liveStatus = 1;

          // }
          if (data.session && data.session.bind_wiki_status && data.session.bind_wiki_user_status) {

            if (data.session.collect_user_profile) {
              this.userAuthInfo = data.session.collect_user_profile
            }
            this.show_bind_wiki = false;
            // // 判断用户认证信息是否完善
            // if (this.liveStatus == 1) {//正在直播时只判断认证信息是否已存在用户真实姓名
            //   if (!(this.userAuthInfo && this.userAuthInfo.username)) {
            //     this.show_collect_username = true
            //   }
            // } else if(this.liveStatus==2){
            if (!(this.userAuthInfo && this.userAuthInfo.age && this.userAuthInfo.username && this.userAuthInfo.job_name && this.userAuthInfo.hospital && this.userAuthInfo.depart_name)) {
              this.show_collect_authInfo = true
            }
            // }
          }
        }
      });
    },
    getDeparts() {
      const method = "POST";
      fetch(MeetingsAuthList, {}, method)
        .then((res) => {
          if (res.code == 0) {
            this.departs = res.data.departs;
            this.ages = res.data.ages;
            this.jobs = res.data.jobs;

            // const defaultAge = this.ages.find(age => age.checked);
            // if (defaultAge) {
            //   this.userAuthInfo.age = defaultAge.name;
            // }
          }
        })
    },
    onSelectAge(val) {
      this.userAuthInfo.age = val.name;
      this.showPickerAge = false

    },
    onSelectJob(val) {
      this.userAuthInfo.job_name = val.name;
      this.showPickerJob = false

    },
    onSelectDepart(val) {
      this.userAuthInfo.depart_name = val.name;
      this.showPickerDepart = false

    },
    //提交认证信息
    submitAuthInfo() {
      if (!(this.userAuthInfo.username && this.userAuthInfo.age && this.userAuthInfo.hospital && this.userAuthInfo.depart_name && this.userAuthInfo.job_name)) {
        Toast.fail('请完整并正确输入');
        return;
      }
      let params = {
        session_id: this.liveDetails.id,
        age: this.userAuthInfo.age,
        username: this.userAuthInfo.username,
        hospital: this.userAuthInfo.hospital,
        job_name: this.userAuthInfo.job_name,
        depart_name: this.userAuthInfo.depart_name
      }
      const method = "POST";
      fetch(CollectUserAuth, params, method)
        .then((res) => {
          if (res.code == 0) {
            this.show_collect_authInfo = false;
            this.show_collect_username = false;
            Toast('提交成功');


          }
        })
    },
    // meeting_id=490提交手机号
    submitPhone() {
      if (this.updateMobile && this.updateMobile.length == 11) {
        let params = {
          mobile: this.updateMobile
        }
        const method = "POST";
        fetch(UpdateUserInfo, params, method)
          .then((res) => {
            if (res.code == 0) {
              this.is_show_phone_popup = false;
              Toast('提交成功');
              setTimeout(() => {
                location.reload()
              }, 1000)

            }
          })
      } else {
        Toast.fail('请正确输入', err);
      }
    },
    //会议密码验证
    confirmMeetingPwd() {
      if (this.meeting_watch_type == 2) {
        if (this.meeting_watch_password == this.passwordInputValue) {
          this.is_show_meeting_password = false
          Toast('密码正确');
        } else {
          Toast('密码输入错误');

        }
      }

    },
    getWxConfig(share_info) {
      let that = this
      if (common.is_weixin()) {
        const url = WxShare;
        let params = {
          "jssdk": ["wx-open-launch-weapp", 'onMenuShareAppMessage', 'onMenuShareTimeline', 'wx-open-subscribe'],
          "url": location.href
        };
        const method = 'POST';
        fetch(url, params, method)
          .then((res) => {
            if (res.code == 0) {
              wx.config({
                debug: false, // 验证结果弹窗控制，微信环境可能会因为接口安全问题出现失败弹窗，所以直接设置的false，
                appId: res.data.appId, // 公众号唯一appid
                nonceStr: res.data.nonceStr,
                timestamp: res.data.timestamp,
                signature: res.data.signature,
                jsApiList: res.data.jsApiList,//随便填写的一个
                openTagList: ['wx-open-launch-weapp', 'wx-open-launch-app', 'wx-open-subscribe']
              })
              wx.ready(function (success) {
                that.isWxBtn = true //表示验证成功
                //分享给朋友
                wx.onMenuShareAppMessage({
                  title: share_info.title, // 分享标题
                  desc: share_info.desc, // 分享描述
                  link: window.location.href, // 分享链接
                  imgUrl: 'http:' + share_info.img, // 分享图标
                  type: 'link', // 分享类型,music、video或link，不填默认为link
                  dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                  success: function () {
                    // 用户确认分享后执行的回调函数


                  },
                  cancel: function () {
                    // 用户取消分享后执行的回调函数
                  }
                });
                //分享到朋友圈
                wx.onMenuShareTimeline({
                  title: share_info.title,
                  link: window.location.href,
                  imgUrl: 'http:' + share_info.img,
                  // type: 'link',
                  success: function () {
                    // 用户确认分享后执行的回调函数
                  },
                  cancel: function () {
                    // 用户取消分享后执行的回调函数
                  }
                });
                console.log('success', success)
              })
              wx.error(function (err) {
                // Toast.fail('暂不支持', err);
                // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
                console.log('error', err)
              })


            }
          })

      }
    },
    getLiveInfo() {
      this.$refs.player.getLiveInfo(this.liveInfo2);
    },
    submitSubscribe() {
      this.$refs.schedule.submitSubscribe();

    },
    //会议广告位
    getBanner() {
      const url = MeetingBanner;
      const method = "POST";
      let params = {
        session_id: this.id
      };
      fetch(url, params, method).then(res => {
        if (res.code == 0) {
          let data = res.data;
          this.swiperImg = data;
        }
      });
    },
    changeLine(item, index) {
      if (index != this.line_index) {
        this.liveDetails["play_url_m3u8"] = item.play_url_m3u8;
        this.$nextTick(() => {
          this.$refs.player.getLiveInfo(this.liveDetails);
        });
        this.line_index = index;
      }
    },
    //会议弹出
    getExtend() {
      const url = extendPop;
      const method = "POST";
      let params = {
        meeting_id: this.meeting_id
      };
      fetch(url, params, method).then(res => {
        if (res.code == 0) {
          let data = res.data;
          this.extend_pop = data;
          // if(true){
          if (data.live_alter_ad) {
            this.is_show_extend = true;
          }
        }
      });
    },
    changeInfoStatus(data) {
      this.showActivity = data;
    },
    //会议会场
    getMeetingsPlace() {
      const url = MeetingsSchedule;
      const method = "POST";
      let params = {
        meeting_id: this.meeting_id,
        from_change_session: 1
      };
      var that = this
      fetch(url, params, method).then(res => {
        if (res.code == 0) {
          let data = res.data;
          this.meetingSchedules = data.sessions;
          if (data.meeting.watch_type == 3 && !data.meeting.white_list_user) {
            console.log('白名单访问没有权限');
            Dialog({
              title: '温馨提示',
              message: data.meeting.white_visit_tip,//自定义提示语
              confirmButtonText: "确定",
            }).then(() => {
              if (window.history.length > 1) { //返回上一页
                that.$router.go(-1)
              } else {
                that.$router.replace('/vascularNews/meeting/index?meeting_id=' + that.meeting_id)//返回首页
              }
            }).catch(() => {
            });

          } else if (data.meeting.watch_type == 2) {
            console.log('会议密码访问');
            this.is_show_meeting_password = true;

          }
          this.meeting_watch_type = data.meeting.watch_type;
          this.meeting_watch_password = data.meeting.watch_password;


          this.scheduleDate = Object.keys(this.meetingSchedules);
          console.log("scheduleDate", this.scheduleDate);
          const dateObj = data.meeting.start_at.split(" ")[0].split("-")[0];
          this.weekdays = [];
          this.scheduleDate.forEach((item, i) => {
            let d = new Date(
              dateObj + "-" + item.replace("月", "-").replace("日", "")
            );
            this.weekdays[i] = [
              "星期日",
              "星期一",
              "星期二",
              "星期三",
              "星期四",
              "星期五",
              "星期六"
            ][d.getDay()];
          });
          console.log(this.weekdays);
          if (data.meeting.theme_color_hex) {
            this.theme_color = data.meeting.theme_color_hex;
          } else {
            this.theme_color = "#901D22";
          }

          if (data.meeting.schedule_color_hex) {
            this.schedule_color = data.meeting.schedule_color_hex;
          }
          if (data.meeting.schedule_font_color_hex) {
            this.schedule_font_color = data.meeting.schedule_font_color_hex;
          }
          if (data.meeting.end_at) {
            this.meetingEndTime = data.meeting.end_at;
          }

          // if (data.meeting.mission_set) {
          // 	this.theme_color = data.meeting.mission_set.color;
          // }
          // scheduleList:[],
        }
      });
    },
    //会议观看人数
    getMeetingNumer() {
      const url = SessionsViewsNum;
      let params = {
        session_id: this.id
      };
      const method = "POST";
      fetch(url, params, method).then(res => {
        if (res.code == 0) {
          let data = res.data;
          this.viewNum = data.views;
        }
      });
    },
    clickSwiperImg(item) {
      window.location.href = item.url;
    },
    changeAuth(data) {
      this.hasAuth = data;
      if (data == true) {
        // let top=this.$refs.line.getBoundingClientRect().top;
        // let bottom=this.$refs.line.getBoundingClientRect().bottom;
        this.getMeetingsPlaceDetails();
        this.getMeetingsPlace();
        this.getMeetingNumer();
        this.getBanner();
      }
    },
    //返回
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.replace('/vascularNews/meeting/index?meeting_id=' + this.meeting_id)
      }
    },
    //得到签名
    getSignature() {
      if (Object.keys(this.signatureInfo).length == 0) {
        const url = Signature;
        const method = "POST";
        let params = {
          scheme: window.location.protocol
        };
        fetch(url, params, method).then(res => {
          if (res.code == 0) {
            let data = res.data;
            this.signatureInfo = data;
            if (!this.userInfo) {
              this.getUserInfo();
            } else {
              this.initWebSocket();
            }
          }
        });
      } else {
        if (!this.userInfo) {
          this.getUserInfo();
        }
      }
    },
    //初始化weosocket
    initWebSocket() {
      // const wsuri = "ws://ws.talkmed.com/xgzx-pro?platform="+platform+"&timestamp="+timestamp+"&uasid="+uasid+"&signature="+signature+"&nickname="+nickname+"&avatar="+avatar;
      const wsuri = this.signatureInfo.ws_url;

      this.websock = new WebSocket(wsuri);
      this.websock.onopen = data => {
        console.log("连接成功");
      };
      this.websock.onmessage = event => {
        this.websocketonmessage(event);
      };
      this.websock.onerror = () => {
        if (this.timeout_count < 5) {
          this.timeout_count++;
          console.log("连接失败，等待15s尝试重连" + this.timeout_count);
          setTimeout(() => {
            this.websocketonerror();
          }, 15000);
        }
      };
      this.websock.onclose = () => {
        this.websocketclose();
      };
    },
    //数据发送
    websocketSendMessage() {
      let params = {
        action: "send_to_all_room_member",
        params: {
          raw: {
            body: this.content
          }
        },
        room_id: this.room_id
      };
      this.websock.send(JSON.stringify(params));
      this.content = "";
    },
    //连接建立失败重连
    websocketonerror() {
      this.initWebSocket();
    },
    //数据接收
    websocketonmessage(res) {
      if (res.data == "pong") return;
      var data = JSON.parse(res.data);
      //连接成功  加入房间
      if (data.code == 201) {
        this.joinRoom();
        this.connectWebSocket = true;
        this.keepSocket();
      } else if (data.code == 200) {
        //正常响应
        // console.log(data.action);
        let str = data.action;
        let userId = this.userInfo ? this.userInfo.ecs_id : 0;
        switch (str) {
          //接收到群发信息
          case "send_to_all_room_member":
            let receiveData = data.data.msg_list[0];
            let obj = {
              avatar: receiveData.avatar,
              msg: `<i>${receiveData.nickname} :</i> ${receiveData.body}`,
              direction: userId == receiveData.from_id ? "right" : "left"
            };
            this.topicList.push(obj);
            // this.backBottom();
            break;
          //消息正在审核中
          case "wait_check_msg":
            common.toast(data.message, 1500);
            break;
        }
      } else if (data.code == 301 || data.code == 403) {
        //被迫下线  签名错误或者验证已过期
        this.getSignature();
      }
    },
    //关闭websocket
    websocketClose() {
      this.websock.close();
    },
    //加入房间
    joinRoom() {
      let nickname = this.userInfo.nickname;
      let avatar = this.userInfo.avatar;
      let obj = {
        type: "room",
        action: "join_room",
        params: {
          nickname: nickname,
          avatar: avatar
        },
        room_id: this.room_id
      };
      this.websock.send(JSON.stringify(obj));
    },
    //  维持心跳  WebSocket Ping Pong
    keepSocket() {
      console.log("ping");
      if (this.connectWebSocket) {
        this.websock.send("ping");
      }
      this.pingTimer = setTimeout(() => {
        this.keepSocket();
      }, 1000 * 30);
    },
    websocketclose(e) {
      console.log("断开连接", e);
    }
  },
  destroyed() {
    window.removeEventListener("popstate", this.goBack, false);
    //退出这个页面  录播url为空
    this.$store.dispatch("receiveVideoUrl", "");
    //建立连接  才可以关闭
    if (this.connectWebSocket) {
      clearTimeout(this.pingTimer);
      this.websocketClose();
    }
  }
};

</script>

<style lang="scss" scoped>
.popup-box {
  padding: 0 20px;
  text-align: center;
  color: #a21016;
  background-image: url('/assets/images/cec2022/med_conference.png');
  background-size: 70% auto;
  background-position: 100% 40%;
  background-repeat: no-repeat;

  h2 {
    margin: 5px 0;
    padding: 0 10px;
    white-space: nowrap;
  }

  .yellowbd {
    border: 3px solid #ce9f70;
    border-radius: 15px;
  }

  button {
    margin: 10px 0;
    padding: 0px 40px;
    border: 3px solid #ce9f70;
    background: white;
    font-weight: 500;
    color: #a21016;
    border-radius: 20px;
    font-size: 16px;
    line-height: 36px;
  }

  /deep/.van-popup__close-icon--top-right {
    top: 0 !important;
    right: 0 !important;
  }
}

.meeting-live1 {
  display: flex;
  flex-direction: column;
  position: relative;

  // overflow-y: scroll;
  // min-height: 100vh;

  .all {
    display: flex;
    width: 100%;
    // height: 100%;
    min-height: calc(100vh - 50px);
    flex-flow: column;
    // overflow-y: scroll;
  }

  .video {
    // position: static;
    // top: 0;
    position: relative;

    .viewNumber {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1000;
      width: 100%;
      height: 20px;
      line-height: 20px;
      text-align: center;
      font-size: 12px;
      color: #fff;
      background: rgba(17, 17, 17, 0.4);
    }

    h3 {
      font-size: 15px;
      color: $color-black;
      flex: 1;
    }
  }

  .swiper-img {
    width: 100%;
    background-color: #fff;

    img {
      width: 100% !important;
    }
  }

  .container {
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: auto;
    position: relative;

  }

  .van-popup {
    border-radius: 5px;
  }

  .activity {
    text-align: center;
    padding: 25px 20px;
    background: linear-gradient(2deg,
        rgba(255, 250, 248, 1) 0%,
        rgba(255, 255, 255, 1) 100%);
    box-shadow: 0px 5px 11px 0px rgba(0, 0, 0, 0.14);
    border-radius: 11px;

    .van-popup__close-icon--top-right {
      font-size: 20px;
      color: #030303;
      top: 10px;
      right: 10px;
    }

    img {
      width: 240px;
      margin: 20px 0;
    }

    button {
      margin: 0 auto;
      width: 165px;
      height: 40px;
      border: 0px;
      background: linear-gradient(180deg,
          rgba(255, 124, 129, 1) 0%,
          rgba(245, 42, 42, 1) 100%);
      box-shadow: 0px 5px 11px 0px rgba(0, 0, 0, 0.14);
      border-radius: 22px;
      // font-size:16px;
      // color:#fff;
      text-shadow: 0px 5px 11px rgba(0, 0, 0, 0.14);

      p {
        display: flex;
        color: #fff;
      }
    }

    >p {
      width: 90%;
      margin: 25px auto;
      text-align: justify;
    }
  }

  .qrcode {
  
    img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 70%;
      height: 70%;
    }
  }
  
@media screen and (min-width: 768px) {
  .qrcode{
    height: 6rem !important;
    width: 6rem !important;
  }
}
  .extend {
    padding: 10px 20px;
    display: flex;
    
    .half {
      width: 50%;
      height: 100%;
      position: relative;

      .attention {
        font-size: 0.58rem;
        font-weight: bold;
        border-bottom: 5px solid #901d22;
        margin-left: 7px;
      }
    }

    img {
      position: absolute;
      top: 50%;
      left: 0px;
      transform: translate(0, -50%);
      width: 80%;
      // height: 120px;
    }

    .extend-content {
      position: absolute;
      top: 50%;
      transform: translate(0, -50%);
    }
  }

  .meeting_des {
    width: 100%;
    padding: 10px;
    box-sizing: border-box;

    img {
      display: block;
      width: 100% !important;
    }
  }

  // 领取礼物
  .receiveGifts {
    @include flex(row);
    align-items: center;
    position: fixed;
    right: 0px;
    bottom: 60px;
    width: 82px;
    height: 44px;
    background: rgba(244, 103, 45, 1);
    box-shadow: 0px 4px 10px 0px rgba(53, 19, 18, 0.27);
    border-radius: 100px 0px 0px 100px;

    img {
      width: 60px;
      position: absolute;
      left: -12px;
    }

    p {
      margin-left: 45px;
      font-size: 11px;
      color: #fff;
      text-align: center;
      text-shadow: 0px 1px 1px rgba(152, 54, 10, 0.46);
    }
  }
}

.timeTabs-wrap {
  overflow: hidden;
  width: 100%;
  background: #fff;
  display: flex;
  align-items: center;
  padding: 0px 15px;
  line-height: 60px;
  justify-content: space-between;

  .icon_hide {
    opacity: 0;
    // transition: opacity 0.5s ease;
  }

  .icon_show {
    opacity: 1;
    transition: opacity 0.6s ease-in;
  }

  .timeTabs-wrap-inner {
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 75%;
    overflow: hidden;
  }

  h3 {
    font-size: 15px;
    font-weight: 500;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.fixed {
  position: fixed;
  top: 0px;
  z-index: 1000;
}

.timeTabs {
  // padding: 0 12px;
  // height: 60px;
  @include flex(row);
  align-items: center;
  overflow: auto;
  flex-shrink: 0;
  // width: 100%;
  // border-bottom: 1px solid #bfbfbf;

  .tab-item {
    font-size: 14px;
    color: #fff;
    width: 70px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    // border: 1px solid #666;
    border-radius: 2px;
    margin-right: 15px;
  }

  .active {
    color: #fff;
    background: #901d22;
    border: 0px;
  }
}

.bgCover2 {
  border-radius: 5px 5px 0 0;
  width: 100%;
  position: relative;
  overflow: hidden;

  img {
    min-height: 110px;
    background-color: #fff;
    width: 100%;
  }

  ul {
    position: absolute;
    top: 0;
    bottom: 15px;
    padding: 22px;
    overflow: hidden;
    width: 100%;

    li,
    p {
      font-size: 16px;
      margin: 10px 0;
    }

    li::before {
      content: "";
      display: inline-block;
      width: 5px;
      height: 5px;
      background: #1a1a1a;
      border-radius: 50%;
      margin-right: 5px;
    }
  }
}

.icon_charge_top {
  width: 56px;
  height: 56px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  z-index: 99999;
  padding-bottom: 220px;

}

.icon_charge_top.sp {
  padding-bottom: 250px;

}

.charge {
  padding: 20px;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  align-items: center;
  border-radius: 10px;

  .filter {
    position: absolute;
    left: -10%;
    top: -20px;
    width: 120%;
    height: 25%;
    opacity: 0.4;
    background: #901D22;
    filter: blur(20px);
  }



  h4 {
    margin: 20px 10px;
    font-size: 18px;
    font-weight: 500;
  }

  h3 {
    margin: 0px 10px 20px;
    font-size: 18px;
    font-weight: 500;
  }

  p {
    color: #666;
    font-size: 15px;
    text-align: center;
  }

  .handles {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    width: 100%;

    div {
      width: 115px;
      height: 42px;
      font-size: 16px;
      line-height: 42px;
      text-align: center;
      border-radius: 5px;
      color: #fff;

    }

    .no {
      background: #F7F7F8;
      color: #666;

    }

    .red {
      background: #901D22;
      color: #fff;

    }

  }
}

@media screen and (min-width: 1000px) {
  #app {
    max-width: 100% !important;
  }

  .meeting-live1 {
    height: 100vh;
  }

  .meeting-live1 .all {
    flex-direction: row;
    flex: 1;
    // height: 100vh;

    &>div:first-child {
      width: 65%;
    }
  }

  .meeting-live1 .container {
    height: 100%;
    padding-bottom: 20px;
    overflow: hidden;
  }

  .meeting-live1 .extend {
    width: 520px !important;
    top: 0 !important;
    bottom: 0 !important;
    left: 0 !important;
    right: 0 !important;
    margin: auto !important;

    img {
      width: 140px;
      top: 60% !important;
    }


  }

  // .live-place1 .live-item {
  //   width: 48% !important;
  //   margin: 0 !important;
  //   margin-right: 4% !important;
  //   margin-bottom: 10px !important;
  // }

  // .live-place1 .live-item:nth-child(2n+1) {
  //   margin-right: 0 !important;
  // }
}

.phone_popup {
  padding: 40px 0px 0;

  h4 {
    text-align: center;
    font-size: 14px;
    margin-bottom: 10px;
  }

  .submit {
    width: 80px;
    line-height: 30px;
    color: #fff;
    background: #901D22;
    border: 1px solid #901D22;
    border-radius: 10px;
    text-align: center;
    margin: 20px auto;
  }
}

.pwd_popup {
  padding: 40px 0px 0;

  h4 {
    text-align: center;
    font-size: 14px;
    margin-bottom: 10px;
  }

  .submit {
    width: 80px;
    line-height: 30px;
    color: red;
    text-align: center;
    margin: 10px auto;
    font-size: 18px;
  }
}
</style>
<style lang="scss">
.meeting-live1 {
  .van-tabs--line {
    height: 100%;
    display: flex;
    flex-direction: column;

    .van-tabs__wrap {
      // height: 60px;
      flex-shrink: 0;
      // overflow: auto;
    }
  }

  .van-tabs__content {
    height: calc(100% - 45px);
  }

  .van-tab__pane-wrapper {
    overflow-y: auto;
  }
}

.charge {
  .van-field {
    padding: 0;
    align-items: center;
    margin-bottom: 15px;
    padding: 6px 10px 6px 20px;
    background: #FAFAFA;
    border: 0.5px solid #DADADA;
    border-radius: 5px;
  }


}
.want_look_tip{
	position: fixed;
	bottom: 30%;
	left: 0;
	right: 0;
  text-align: center;
	margin: auto !important;
	width: 300px;
	background: rgba($color: #000000, $alpha: 0.7);
	color: #fff;
	padding: 10px 15px;
	border-radius: 5px;
  font-size: 13px;
  z-index: 99;
}
</style>



// WEBPACK FOOTER //
// src/pages/VascularSystem/Meeting/LiveDetail.vue